import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ApprovedProjects.css";
import ProgressiveImage from "../components/Image/ProgressiveImage";

function clipText(text, maxLength) {
  if (text.length > maxLength) {
    let clipped = text.substring(0, maxLength);
    let lastSpace = clipped.lastIndexOf(" ");
    if (lastSpace > 0) {
      clipped = clipped.substring(0, lastSpace);
    }
    return clipped + "...";
  }
  return text;
}



function ApprovedProjects({ data }) {
  const [topThree, setTopThree] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setTopThree(data
        .filter(proj => proj.Decision?.toLowerCase() === "approved")
        .sort(() => Math.random() - 0.5)
        .slice(0, 3));
    }
  }, [data]);

  return (
    <section className="approved-projects">
      <h2>Approved Projects</h2>
      <div className="approved-projects__container">
        {topThree.map((project) => (
          <div
            key={project.ProjectReference}
            className="approved-project"
            onClick={() => navigate(`/project/${project.ProjectReference}`, { state: project })}
          >
            <ProgressiveImage
              src={project.ImageURL.replace(/\s+/g, '')}
              placeholderSrc={project.ImageURL.replace(/\s+/g, '').replace('/images/','/thumbs/')}
              alt={project.ProjectName}
            />
            <div className="approved-project__content">
              <h3>{project.ProjectName}</h3>
              <p>{clipText(project.Description, 100)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ApprovedProjects;
